<template>
	<div class="card-container">

		<post-smtp-card
			type="all"
			:is-pro="postSmtpPro"
			class="post-smtp-card-box"
		>

			<template v-slot:count>
				<div v-if="postSmtpConfigured">
					{{ totalEmails }}
				</div>

				<div v-else>
					0
				</div>
			</template>

			<template v-slot:content>
				<div>
					{{ i18n.total }}
					<br>
					<span
						class="post-smtp-content-lighter"
						v-if="postSmtpConfigured"
					>{{ title }}</span>

					<span
						class="post-smtp-content-lighter"
						v-else
					>-</span>
				</div>
			</template>
		</post-smtp-card>

		<post-smtp-card
			type="success"
			:is-pro="postSmtpPro"
			class="post-smtp-card-box"
		>

			<template v-slot:count>
				<div
					v-if="postSmtpConfigured"
				>
					{{ successEmails }}
				</div>

				<div
					v-else
				>0</div>
			</template>

			<template v-slot:content>
				<div>
					{{ i18n.success }}
					<br>
					<span
						class="post-smtp-content-lighter"
						v-if="postSmtpConfigured"
					>{{ title }}</span>

					<span
						class="post-smtp-content-lighter"
						v-else
					>-</span>
				</div>
			</template>
		</post-smtp-card>

		<post-smtp-card
			type="failed"
			:is-pro="postSmtpPro"
			class="post-smtp-card-box"
		>

			<template v-slot:count>
				<div
					v-if="postSmtpConfigured"
				>
					{{ failedEmails }}
				</div>

				<div
					v-else
				>0</div>
			</template>

			<template v-slot:content>
				<div>
					{{ i18n.failed }}
					<br>
					<span
						class="post-smtp-content-lighter"
						v-if="postSmtpConfigured"
					>{{ title }}</span>

					<span
						class="post-smtp-content-lighter"
						v-else
					>-</span>
				</div>
			</template>
		</post-smtp-card>

		<!--	v-if=! isPro	-->
		<post-smtp-card
			type="opened--pro"
			v-if="! postSmtpPro"
			class="pro-remove-margin"
			@click="redirectToPro"
			style="cursor: pointer;"
		>

			<template v-slot:count>
				<div style="margin-bottom: 5px;" class="pro-content-header">
					{{ i18n.openedPro.title }}
				</div>
			</template>

			<template v-slot:content>
				<post-smtp-img
					style="margin-right: 4px;margin-bottom: -2px;"
					:src="plugin_dir_url + 'assets/images/pro-lock.svg'"
					alt="Unlock"
				></post-smtp-img>
				<a target="_blank" href="https://postmansmtp.com/pricing/?utm_source=dashboard&utm_medium=pro_grid&utm_campaign=plugin">
					<span class="pro-content">
						{{ i18n.openedPro.subTitle }}
					</span>
				</a>
			</template>
		</post-smtp-card>
		<!--	v-endif	-->

		<post-smtp-card
			type="opened--pro"
			:is-pro="postSmtpPro"
			v-if="postSmtpPro"
			class="post-smtp-card-box"
		>

			<template v-slot:count>
				<div
					v-if="postSmtpConfigured"
				>
					{{ openedEmails }}
				</div>

				<div
					v-else
				>0</div>
			</template>

			<template v-slot:content>
				<div>
					{{ i18n.opened }}
					<br>
					<span
						class="post-smtp-content-lighter"
						v-if="postSmtpConfigured"
					>{{ title }}</span>

					<span
						class="post-smtp-content-lighter"
						v-else
					>-</span>
				</div>
			</template>
		</post-smtp-card>

	</div>
</template>

<script>
export default {
	name: 'PostSmtpCardsContainer',

	props: {
		period: {
			type: String,
			default: () => 'month',
		},

		postSmtpConfigured: {
			type: Boolean,
			default: false,
		},

		postSmtpPro: {
			type: Boolean,
			default: false,
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,

		totalEmails: '0',
		successEmails: '0',
		failedEmails: '0',
		title: '',

		openedEmails: '0',

    i18n: postSmtpNewDashboard.i18n.cards,
	} ),

	watch: {
		period( newValue ) {
			this.getLogsCounts( newValue );
		}
	},

	methods: {
		getTitle( period ) {
			switch ( period ) {
				case 'day':
					return this.i18n.days[0];

				case 'week':
					return this.i18n.days[1];

				case 'month':
					return this.i18n.days[2];
			}
		},

		getLogsCounts( period ) {
			axios.get( 'email-count', {
				params: {
					period: period,
				}
			} )
				.then( response => {
					if ( typeof response.data.count != "undefined" ) {
						this.totalEmails = response.data.count.total;
						this.successEmails = response.data.count.success;
						this.failedEmails = response.data.count.failed;

					}

					if ( this.postSmtpPro ) {
						this.openedEmails = response.data.count.opened || 0;
					}

					this.title = this.getTitle( period );
				} );
		},

		redirectToPro() {
			window.open( 'https://postmansmtp.com/pricing/?utm_source=dashboard&utm_medium=pro_grid&utm_campaign=plugin', '_blank' );
		}
	},


	mounted() {
		this.getLogsCounts( this.period );
	}
}
</script>

<style scoped>
.card-container * {
	padding: 0;
	margin: 0;
}

.card-container::after {
	content: "";
	display: table;
	clear: both;
}

.post-smtp-content-lighter {
	color: #231F20;
	font-family: Poppins;
	font-size: 10px;
	font-style: normal;
	font-weight: 500;
	line-height: 13px;
}

.pro-content-header {
	color: #5A3F17;
	text-align: center;
	font-family: Poppins;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 14px; /* 100% */
}

.pro-content {
	color: #5A3F17;
	text-align: center;
	font-family: Poppins;
	font-size: 11px;
	font-style: normal;
	font-weight: 500;
	line-height: 13px; /* 118.182% */
	text-decoration-line: underline;
}

.post-smtp-card-box[is-pro="true"] .post-smtp-content-lighter {
	color: #fff;
}
</style>